import { CaseType } from "@/types/casesFrontendTypes";
import { TransactionType } from "@/types/transactionsFrontendTypes";
import { createServerEndpoint, isValidData } from "@/utils/functions";
import axios from "axios";
import { OriginalTransactionsType } from "../../../../rca-app-server/src/types/transactions";

const state = () => ({
  transactions: [] as TransactionType[],
  originalTransactions: [] as OriginalTransactionsType[],
  riskPatternKind: null as CaseType | null
});

const getters = {
  rp_type(state: any): string | null {
    const first = state.transactions[0];
    if (isValidData(first)) {
      return first.risk_pattern;
    } else {
      return null;
    }
  },
  rp_case_locale(state: any): string | null {
    const first = state.transactions[0];
    if (isValidData(first)) {
      return first.country;
    } else {
      return null;
    }
  }
};

const mutations = {
  REGISTER_RISK_PATTERN_TYPE(state: any, pattern: CaseType) {
    state.riskPatternKind = pattern;
  },
  SET_TRANSACTIONS(state: any, transactions: TransactionType[]) {
    state.transactions = transactions;
  },
  SET_ORIGINAL_TRANSACTIONS(
    state: any,
    originalTransactions: OriginalTransactionsType[]
  ) {
    state.originalTransactions = originalTransactions;
  }
};

const actions = {
  async FETCH_DATA({ commit }: any, id: string) {
    const endpointRaw = createServerEndpoint(
      "/api/cases/{case_id}/transactions"
    );
    const endpoint = endpointRaw.replace("{case_id}", id);

    try {
      const { data } = await axios.get<TransactionType[]>(endpoint);
      commit("SET_TRANSACTIONS", data);
    } catch (error) {
      console.error(error);
      commit("SET_TRANSACTIONS", []); // Set an empty array in case of an error
    }
  },

  async FETCH_ORIGINAL_TRANSACTIONS({ commit }: any, id: string) {
    const endpointRaw = createServerEndpoint(
      "/api/cases/{case_id}/original_transactions"
    );
    const endpoint = endpointRaw.replace("{case_id}", id);

    try {
      const { data } = await axios.get<OriginalTransactionsType[]>(endpoint);
      commit("SET_ORIGINAL_TRANSACTIONS", data);
    } catch (error) {
      console.error(error);
      commit("SET_ORIGINAL_TRANSACTIONS", []); // Set an empty array in case of an error
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
